/* eslint-disable */
import React from 'react'
const VideoTriangleIcon = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 19 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 9.26795C19.3333 10.0377 19.3333 11.9623 18 12.7321L3 21.3923C1.66667 22.1621 0 21.1999 0 19.6603L0 2.33975C0 0.800145 1.66667 -0.162105 3 0.607696L18 9.26795Z"
      fill="white"
    />
  </svg>
)

VideoTriangleIcon.defaultProps = {
  width: 19,
  height: 22,
}

export default VideoTriangleIcon
